import ArrowLeft from "@mui/icons-material/ArrowLeft";
import { Box, Grid, Link } from "@mui/material";
import Bouton from "../../../components/Button/Bouton";
import FormContainer from "../../../components/FormContainer";
import Layout from "../../../components/Layout";
import LoadingBoundary from "../../../components/LoadingBoundary";
import Snack from "../../../components/Snack";
import Spinner from "../../../components/spinner/Spinner";
import styles from "../styles";
import ContratLoyerImpayes from "./ContratsLoyersImpayes";
import DetailActivite from "./DetailActivite";
import ProfilsUtilisateurs from "./ProfilsUtilisateurs";
import { useConsulterAdb } from "./selectors";
import Habilitations from "./Habilitations";

function ConsulterAdbPage() {
  const {
    adbDetail,
    adbId,
    username,
    fetchingActiverAdb,
    fetchingDesactiverAdb,
    errorDesactiver,
    errorAdbActiver,
    adbError,
    activerAdb,
    adbFetching,
    desactiverAdb,
    emptyErrorMessages,
    infoProfil,
  } = useConsulterAdb();
  /**
   * Fonction permettant de délencher l'activation'.
   */
  const handleActiver = (id?: number) => {
    const params = {
      id,
      adbActiver: {
        username: username,
      },
    };
    activerAdb(params);
  };
  /**
   * Fonction permettant de délencher la désactivation.
   */
  const handleDesactiver = (id?: number) => {
    id && desactiverAdb(id);
  };

  const renderField = (label: string, value?: number | string) => {
    return (
      <p className={"paragraph"}>
        {label} : <strong>{value}</strong>
      </p>
    );
  };

  const handleClose = () => {
    emptyErrorMessages();
  };

  const renderError = (error: any) => {
    return (
      <Snack
        onClose={handleClose}
        open={true}
        variant="error"
        message={error.message}
      />
    );
  };
  // const dataConsultation =
  //   adbDetail &&
  //   adbId &&
  //   adbDetail.find((detail) => detail.identifiant === adbId);

  return (
    <Layout title={"Consulter un adb"}>
      <Box sx={styles}>
        {adbDetail ? (
          <LoadingBoundary loading={adbFetching} error={adbError}>
            <>
              <Link
                href="/mes-administrateurs-de-biens"
                color="inherit"
                className={"link"}
              >
                <ArrowLeft /> Retour au tableau
              </Link>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <Grid item className={"containerTitle"}>
                  <h2 className={"titreSecondaire"}>Visualisation d'un Adb</h2>
                  {adbDetail.applications &&
                    adbDetail.applications[0] &&
                    adbDetail.applications[0].parametrage &&
                    adbDetail.applications[0].parametrage.actif && (
                      <Link
                        href="/dashboard"
                        color="secondary"
                        underline="always"
                      >
                        Voir les dossiers de location
                      </Link>
                    )}
                </Grid>

                <Grid item>
                  {adbDetail.applications &&
                  adbDetail.applications[0] &&
                  adbDetail.applications[0].parametrage &&
                  adbDetail.applications[0].parametrage.actif ? (
                    <Bouton
                      label="Bloquer"
                      variant="contained"
                      color="primary"
                      size="medium"
                      fetching={fetchingDesactiverAdb}
                      onClick={() => handleDesactiver(adbDetail.identifiant)}
                    />
                  ) : (
                    <Bouton
                      label="Activer"
                      variant="contained"
                      color="primary"
                      fetching={fetchingActiverAdb}
                      size="medium"
                      onClick={() => handleActiver(adbDetail.identifiant)}
                    />
                  )}
                </Grid>
              </Grid>
              <FormContainer>
                <Grid className={"ligne"}>
                  {renderField("Identifiant adhérent", adbDetail.identifiant)}
                  {adbDetail.titreAdb &&
                    renderField("Statut", adbDetail.titreAdb.libelle)}
                  {renderField("Nom adhérent", adbDetail.nom)}

                  {adbDetail.commercial &&
                    renderField(
                      "Nom commercial",
                      adbDetail.commercial.prenom +
                        " " +
                        adbDetail.commercial.nom
                    )}
                  {adbDetail.adresse1 &&
                    renderField("Adresse - Ligne 1", adbDetail.adresse1)}
                  {adbDetail.adresse2 &&
                    renderField("Adresse - Ligne 2", adbDetail.adresse2)}
                  {adbDetail.adresse3 &&
                    renderField("Adresse - Ligne 3", adbDetail.adresse3)}
                  {renderField("Code Postal", adbDetail.codePostal)}
                  {renderField("Ville", adbDetail.ville)}
                  {adbDetail.identifiant &&
                    infoProfil?.fonctions?.find(
                      (f) => f === "PRMDRTADB_ECRITURE"
                    ) && (
                      <Habilitations
                        idAdb={adbDetail.identifiant}
                        parcoursLocataire={
                          adbDetail.habilitations?.parcoursCandidatLocataire
                        }
                      />
                    )}
                  {adbDetail.applications !== undefined && (
                    <>
                      <DetailActivite
                        dataConsultation={adbDetail}
                        renderField={renderField}
                      />
                      <ContratLoyerImpayes dataConsultation={adbDetail} />
                      <ProfilsUtilisateurs dataConsultation={adbDetail} />
                    </>
                  )}
                </Grid>

                <Grid
                  container
                  justifyContent="flex-end"
                  sx={{ marginTop: "12px" }}
                >
                  {errorAdbActiver && renderError(errorAdbActiver)}
                  {errorDesactiver && renderError(errorDesactiver)}
                </Grid>
              </FormContainer>
            </>
          </LoadingBoundary>
        ) : (
          <Spinner />
        )}
      </Box>
    </Layout>
  );
}

export default ConsulterAdbPage;
